export const GAME_KEYS = {
  candyCrush: 'candy_crush',
  matchsticks: 'matchsticks',
  rangoli: 'rangoli',
};

export const STALLS = [
  {
    id: 'candy',
    gameKey: GAME_KEYS.candyCrush,
    route: '/games/candy-crush',
    tile: '/img/s-1.png',
    title: 'Veggie Align',
  },
  {
    id: 'matchsticks',
    gameKey: GAME_KEYS.matchsticks,
    route: '/games/matchsticks',
    tile: '/img/s-3.png',
    title: 'Matchsticks',
  },
  {
    id: 'rangoli',
    gameKey: GAME_KEYS.rangoli,
    route: '/games/rangoli',
    tile: '/img/s-4.png',
    title: 'Rangoli',
  },
];

export const MATCHSTICK_CORRECT = [
  'stick-v-4',
  'stick-h-3',
  'stick-h-5',
  'stick-h-8',
  'stick-h-7',
  'stick-h-9',
  'stick-v-14',
  'stick-h-17',
  'stick-h-18',
  'stick-v-22',
  'stick-h-19',
  'stick-v-24',
];

export const GAME_COPY = {
  candy_crush: {
    title:
      'Harvesting vegetables at the right stage of maturity ensures the best taste and quality. Align the veggies by selecting 3 or more of a kind together in a row and do the maximum you can in 2 minutes.',
    rules: [
      'You have 2 minutes to play this game',
      'Align the veggies to get the maximum score',
      'Scores for the first attempt will be considered',
    ],
  },
  matchsticks: {
    title:
      'I am a mixture of sweet boiled rice. I also share my name with a harvest festival in south India. Identify me within 2 minutes by clicking on the matchsticks that need to be eliminated.',
    rules: [
      'You have 2 minutes to Identify the word',
      'For every wrong attempt, 1 point will be deducted',
      'Scores for the first attempt will be considered',
    ],
  },
  rangoli: {
    title: 'Put on your creativity hat and design a Rangoli that best fits the occasion!',
    rules: [
      'You earn 10 points for designing a Rangoli',
      'You can play unlimited times',
      'Scores for the first attempt will be considered',
    ],
  },
};

export const HUB_RULES = [
  'Engage in all 3 stalls to earn maximum points',
  'Points are considered for only first attempt on all stalls',
];
